(() => {
	$(() => {
		// Base code used on all pages
		base();

		// Homepage code
		homepage();

		// Subpage code
		subpage();

		// Services code
		services();

		// Pricing code
		pricing();
	});
})();
